import '../styles/app.scss';
import { initSectionsChips } from './blocks/sections-chips.js';
import { initSectionsList } from './blocks/sections-list.js';
import { initCategoryNavSwiper } from './blocks/swiper-sliders.js';
import { initProductCards } from './blocks/product-card.js';
import { initProductCardLine } from './blocks/product-card-line.js';
// TEMP: pdp__improvement.flower-tag отключён до подключения A/B-теста
// import { initFlowerTag } from './blocks/flower-tag.js';
import { initProductsSliders } from './blocks/products-slider.js';
import { initPdpReviews } from './blocks/pdp-reviews.js';
import { initPdpBuySticky } from './blocks/pdp-buy-sticky.js';
import { initPdpLine } from './blocks/pdp-line.js';
import { initShare } from './blocks/share.js';
import { initBlogListing } from './blocks/blog-listing.js';
import { initBlockContents } from './blocks/block-contents.js';
import { initAboutBanners } from './blocks/about-banners.js';
import { initStoreAddresses } from './blocks/store-addresses.js';
import { initCatalogAutoload } from './blocks/catalog-autoload.js';
import { initFooter } from './blocks/footer.js';
import { initHeaderMegaMenu } from './blocks/header-mega-menu.js';
import { initHeaderSearchPanel } from './blocks/header-search-panel.js';
import { initMobileMenu } from './blocks/mobile-menu.js';
import { initMobileHeader } from './blocks/mobile-header.js';
import { initHeaderOffset } from './blocks/header-offset.js';
import { initAuthSheet } from './blocks/auth-sheet.js';
import { initFancyboxSheet } from './blocks/fancybox-sheet.js';
import { initWishHitGuard } from './blocks/wish-hit-guard.js';

import { initDetailGallery } from './blocks/detail-gallery-snap.js';

window.ProstocvetInitSectionsChips = initSectionsChips;
window.ProstocvetInitSectionsList = initSectionsList;
window.ProstocvetInitCategoryNavSwiper = initCategoryNavSwiper;
window.ProstocvetInitProductCards = initProductCards;
window.ProstocvetInitProductCardLine = initProductCardLine;
window.ProstocvetInitDetailGallery = initDetailGallery;
// TEMP: pdp__improvement.flower-tag отключён до подключения A/B-теста
// window.ProstocvetInitFlowerTag = initFlowerTag;
window.ProstocvetInitProductsSliders = initProductsSliders;
window.ProstocvetInitPdpReviews = initPdpReviews;
window.ProstocvetInitPdpBuySticky = initPdpBuySticky;
window.ProstocvetInitPdpLine = initPdpLine;
window.ProstocvetInitShare = initShare;
window.ProstocvetInitBlogListing = initBlogListing;
window.ProstocvetInitBlockContents = initBlockContents;
window.ProstocvetInitAboutBanners = initAboutBanners;
window.ProstocvetInitStoreAddresses = initStoreAddresses;
window.ProstocvetInitFooter = initFooter;
window.ProstocvetInitHeaderMegaMenu = initHeaderMegaMenu;
window.ProstocvetInitHeaderSearchPanel = initHeaderSearchPanel;
window.ProstocvetInitMobileMenu = initMobileMenu;
window.ProstocvetInitMobileHeader = initMobileHeader;
window.ProstocvetInitHeaderOffset = initHeaderOffset;
window.ProstocvetInitAuthSheet = initAuthSheet;
window.ProstocvetInitFancyboxSheet = initFancyboxSheet;

function boot() {
  initSectionsChips();
  initSectionsList();
  initCategoryNavSwiper();
  initProductCards();
  initProductCardLine();
  // Offers PDP boots via `pdp-gallery:refresh` after slides are injected.
  // Noffer (floristics / cards / decor) already has slides in HTML — init now.
  if (!document.querySelector('.catalog_detail .item_main_info[data-pdp-offer-ready="0"]')) {
    initDetailGallery();
  }
  // TEMP: pdp__improvement.flower-tag отключён до подключения A/B-теста
  // initFlowerTag();
  initProductsSliders();
  initPdpReviews();
  initPdpBuySticky();
  initPdpLine();
  initShare();
  initBlogListing();
  initBlockContents();
  initAboutBanners();
  initStoreAddresses();
  initCatalogAutoload();
  initFooter();
  initHeaderMegaMenu();
  initHeaderSearchPanel();
  initMobileMenu();
  initMobileHeader();
  initHeaderOffset();
  initAuthSheet();
  initFancyboxSheet();
  initWishHitGuard();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

window.addEventListener('load', () => {
  initProductCards();
  initProductCardLine();
  // TEMP: pdp__improvement.flower-tag отключён до подключения A/B-теста
  // initFlowerTag();
  initProductsSliders();
  initPdpReviews();
  initPdpBuySticky();
  initPdpLine();
  initShare();
  initBlogListing();
  initBlockContents();
  initAboutBanners();
  initStoreAddresses();
  initMobileHeader();
  initHeaderOffset();
  initSectionsList();
  initCategoryNavSwiper();
});
